import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import React__default from 'react';
import styled from 'styled-components';
import { AnimatedBox } from '../layout/AnimatedBox.js';
import { ModalContext } from './ModalContext.js';
var Motion = styled(AnimatedBox)(css({
  zIndex: "modal",
  width: ["100%", "500px"],
  minHeight: ["100vh", "200px"],
  maxHeight: ["100%", "90%"],
  display: "flex",
  flexDirection: "column",
  boxShadow: "modal",
  backgroundColor: "modalBackground",
  borderRadius: ["0", "16px"]
}), css({
  minHeight: ["-webkit-fill-available", "200px"]
}));
var ModalContent = React__default.forwardRef(function (_a, ref) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  var _b = React__default.useContext(ModalContext),
    isAnimated = _b.isAnimated,
    _c = _b.hasInitialAnimation,
    hasInitialAnimation = _c === void 0 ? true : _c,
    _d = _b.hasExitAnimation,
    hasExitAnimation = _d === void 0 ? true : _d;
  return React__default.createElement(Motion, __assign({}, props, {
    ref: ref,
    transition: {
      ease: "linear",
      duration: isAnimated ? 0.2 : 0
    },
    variants: {
      exit: {
        opacity: 0,
        y: 24
      },
      enter: {
        opacity: 1,
        y: 0
      }
    },
    initial: hasInitialAnimation ? "exit" : "enter",
    animate: "enter",
    exit: hasExitAnimation ? "exit" : "enter"
  }), children);
});
export { ModalContent };